document.addEventListener('DOMContentLoaded', () => {

    const isSmallScreen = window.innerWidth < 1101;

    let suitesOvSwiper = new Swiper('.suites-ov__swiper',{
        loop: true,
        speed: 700,
        spaceBetween: 15,
        navigation: {
            nextEl: '.suites-next',
            prevEl: '.suites-prev'
        },
        slidesPerView: isSmallScreen ? 1 : 3,
        effect: isSmallScreen ? 'fade' : undefined,
        fadeEffect: isSmallScreen ? { crossFade: true } : undefined,
    });

    if(document.querySelector(".dining-overview__swiper")) {
        let diningOvSwiper = new Swiper('.dining-overview__swiper',{
            loop: true,
            speed: 700,
            slidesPerView: 1, 
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            breakpoints: {
                320: {
                    allowTouchMove: true
                },
                600:{
                    allowTouchMove: false
                }
            }
        });

        let diningOvTitleSwiper = new Swiper('.dining-overview__swiper--titles',{
            loop: true,
            speed: 700,
            navigation: {
                nextEl: '.dining-ov-next',
                prevEl: '.dining-ov-prev'
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 0
                },
                600:{
                    centeredSlides: false,
                    spaceBetween: 20,
                    slidesPerView: "auto", 
                }
            }
        });

        diningOvSwiper.on('slideChange', function () {
            let activeIndex = this.realIndex;
            if (diningOvTitleSwiper.realIndex !== activeIndex) {
                diningOvTitleSwiper.slideToLoop(activeIndex, 700, false);
            }
        });
    
        diningOvTitleSwiper.on('slideChange', function () {
            let activeIndex = this.realIndex;
            if (diningOvSwiper.realIndex !== activeIndex) {
                diningOvSwiper.slideToLoop(activeIndex, 700, false);
            }
        });
    }

    let gallerySwiper = new Swiper('.gallery-block__swiper',{
        loop: true,
        speed: 800,
        navigation: {
            nextEl: '.gallery-next',
            prevEl: '.gallery-prev'
        },
        breakpoints: {
            320: {
                slidesPerView: 1
            },
            600:{
                slidesPerView: 2,
                centeredSlides: true
            }
        }
    });

    let columnsSwiper = new Swiper('.columns-swiper',{
        loop: true,
        speed: 800,
        spaceBetween: 25,
        navigation: {
            nextEl: '.columns-next',
            prevEl: '.columns-prev'
        },
        breakpoints: {
            320: {
                slidesPerView: 1
            },
            900:{
                slidesPerView: 3
            }
        }
    });
});